import { useEffect } from "react";

const AD_SLOT_ID = "XXXXXXXXXX"; // Replace with real slot ID once AdSense approved

export function AdBanner() {
  // Don't render until we have a real ad slot ID and we're in production
  if (process.env.NODE_ENV !== "production") return null;
  if (AD_SLOT_ID === "XXXXXXXXXX") return null;

  return (
    <div style={{ textAlign: "center", margin: "12px 0" }}>
      <p style={{ fontSize: "10px", color: "#999", fontFamily: "'Montserrat', sans-serif", margin: "0 0 4px 0" }}>
        Advertisement
      </p>
      <AdBannerInner />
    </div>
  );
}

function AdBannerInner() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-1402942000314474"
      data-ad-slot="XXXXXXXXXX"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
